import React, { useEffect, useState } from 'react';
import { Notification, Admin } from '../assets/DataStructures';
import { Diary } from '../assets/DataStructures';
import {
  IonContent,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonGrid,
  IonRow,
  IonCol,
  IonModal,
  IonIcon
} from '@ionic/react';

import { addCircle } from 'ionicons/icons';
import { Button } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Dialog from '@material-ui/core/Dialog';

import { DiaryGeneralEditForm } from '../pages/DiaryGeneralEditForm';
import { DiaryIDsAppendForm } from '../pages/DiaryIDsAppendForm';
import { CSVLink } from "react-csv";
import useStyles from '../assets/cssClasses';
import Axios from 'axios';
import {URLS} from '../assets/URLS';
import {NotificationComponent} from '../components/NotificationComponent'

import {DialogTitle, DialogContent, DialogContentText, DialogActions} from '@material-ui/core';
import {CancelRounded, EditRounded, CloudDownloadRounded} from '@material-ui/icons';
interface DiaryAdminProps {
  diary: Diary,
  id: string,
  onDelete: any,
  admin: Admin | null
}




const DiaryForAdmin: React.FC<DiaryAdminProps> = (props) => {
  const [diary, setDiary] = useState<Diary>(new Diary());
  const [csvData, setCSVData] = useState<Array<string[]>>([])
  const classes = useStyles();
  const [open_del, setOpenDel] = useState<boolean>(false);
  const [processing, setProcessing] = useState<boolean>(false);

  const [openedit, setOpenEdit] = useState<boolean>(false);
  const [open_append_ids, setOpenAppendIDs] = useState<boolean>(false);



  useEffect(() => {
    setDiary(props.diary);
    

  }, [props.diary])

  useEffect(() => {
    var csv_arr = [];

    for (var user_id in diary.users) {
      //console.log([user_id.toString(), diary.users[user_id].id, diary.users[user_id].link]);
      csv_arr.push([user_id.toString(), diary.users[user_id].id, diary.users[user_id].link, 'https://dsm.bright-mr.com/tab1?duid='+user_id.toString()]);
    }
    console.log(csv_arr);
    setCSVData(csv_arr);
  }, [diary])


  const updateDiary = () => {
    setOpenEdit(true);
  }


  const appendIDs = () => {
    setOpenAppendIDs(true);
  }

  const handleOpenDel = () => {
    setOpenDel(true);
  }

  const handleCloseDel = () => {
    setOpenDel(false);
  }

  const delMessage = (ind: number) => {
    var n_diary = diary;
    n_diary.messages.splice(ind,1);
    setDiary(n_diary);
    postSurvey();
  }

  const postSurvey = () =>{
    setProcessing(true);
    console.log(diary);
    var formData = new FormData();
    
    formData.append('varsList', diary.file);
    formData.append('path', diary.path);
    formData.append('respondent_name', diary.respondent_name);
    formData.append('description', diary.description);
    formData.append('baseURL', diary.url);
    formData.append('apiKey', diary.api_key);
    formData.append('name', diary.name);
    formData.append('notifications', JSON.stringify(diary.messages));
    formData.append('admin', props.admin?props.admin.email:'');
    formData.append('active', JSON.stringify(diary.active));
 
      formData.append('id', props.id?props.id:'');


      Axios.post(URLS.post_survey, formData).then(function(response){
        setProcessing(false);
      })

  }

  const addAutomatedNotification = () => {
    var n_messages = diary.messages?[...diary.messages]:[];
    n_messages.push(new Notification());
    setDiary({...diary,messages: n_messages});
  }



  const setAutoNotification = (ind: number, notification: Notification) => {
    console.log({ind: ind, notification: notification});
 
    diary.messages[ind] = notification;
 
  }

  return (
    <IonCard>
      <IonCardHeader>
        <IonCardTitle className={classes.survey_header}>
          <span className={classes.left_align_block}>{diary.name}</span>
          <span className={classes.right_align_block}>
            
            <Button className={classes.actionButton}><CloudDownloadRounded/><CSVLink data={csvData} className={classes.a_link}>DOWNLOAD</CSVLink></Button>
            <Button onClick={handleOpenDel} className={classes.delButton}><CancelRounded/>Delete</Button>
            
          </span>
        </IonCardTitle>
      </IonCardHeader>

      <IonCardContent>
        <IonGrid>
          <IonRow>
            <IonCol sizeLg="2" sizeMd="4">ID</IonCol>
            <IonCol sizeLg="10" sizeMd="8">{props.id}</IonCol>
          </IonRow>
          <IonRow>
            <IonCol sizeLg="2" sizeMd="4">API key</IonCol>
            <IonCol sizeLg="10" sizeMd="8">{diary.api_key}</IonCol>
          </IonRow>
          <IonRow>
            <IonCol sizeLg="2" sizeMd="4">Path</IonCol>
            <IonCol sizeLg="10" sizeMd="8">{diary.path}</IonCol>
          </IonRow>
          <IonRow>
            <IonCol sizeLg="2" sizeMd="4">URL</IonCol>
            <IonCol sizeLg="10" sizeMd="8">{diary.url}</IonCol>
          </IonRow>
          {diary.users &&
            <IonRow>
              <IonCol sizeLg="2" sizeMd="4">Respondents count</IonCol>
              <IonCol sizeLg="10" sizeMd="8">{Object.keys(diary.users).length}</IonCol>
            </IonRow>
          }
          <Button onClick={updateDiary} className={classes.actionButton}><EditRounded/>EDIT GENERAL SETTINGS</Button>
          <Button onClick={appendIDs} className={classes.actionButton}><EditRounded/>Append IDs</Button>
     

          {diary.messages &&
            <React.Fragment>
              <IonRow>
                <IonCol size="12" className={classes.greyed_title}>Messages</IonCol>
              </IonRow>
              {diary.messages?.map((a,ind)=>{
              return(
                <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3a-content"
          id="panel3a-header"
        >
              {a.push_title?a.push_title:'NEW NOTIFICATION'} - {a.push_message?a.push_message:"Click hereto edit"}
        </AccordionSummary>
        <AccordionDetails>
        <NotificationComponent auto_notification={a} propagateToParent={(notification: Notification) => setAutoNotification(ind, notification)} onDelete={() => delMessage(ind)} mode='view'  saveParent={postSurvey} survey_id={props.id} id={ind.toString()}></NotificationComponent>
        </AccordionDetails>
      </Accordion>
                )
            })}
              
            </React.Fragment>
          }
          <Button onClick={addAutomatedNotification} color="primary" className={classes.actionButton} startIcon={<IonIcon icon={addCircle}/>}>Add Notification</Button>

        </IonGrid>
    
          <IonModal isOpen={openedit} onDidDismiss={()=>setOpenEdit(false)}>
            <IonContent>
              <DiaryGeneralEditForm diary={diary} type="UPDATE" id={props.id} />
            </IonContent>
          </IonModal>

          <IonModal isOpen={open_append_ids} onDidDismiss={()=>setOpenAppendIDs(false)}>
            <IonContent>
              <DiaryIDsAppendForm diary={diary} id={props.id} />
            </IonContent>
          </IonModal>
       

      <Dialog
        open={open_del}
        onClose={handleCloseDel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Delete this survey?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this survey?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDel} color="primary">
            Disagree
          </Button>
          <Button onClick={props.onDelete} color="primary" autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
        

      </IonCardContent>
    </IonCard>
  )
}

export { DiaryForAdmin };